<template>

    <div class="border border-light">

        <!--<div class="font-weight-bold"> Sitting date: {{ formatDateTime(sittingDate, 'DD/MM/YYYY') }}</div>-->

        <ul class="list-group list-group-flush" v-if="blankAudioSegmentsLocal.length == 0">
            <li class="list-group-item">
                The list of blank audio segments is currently empty
            </li>
        </ul>

        <b-table striped small hover :items="blankAudioSegmentsLocal" :fields="tableFields" v-if="blankAudioSegmentsLocal.length > 0">
            <template v-slot:cell(actions)="row" v-if="!readonly">
                <b-button-group>

                    <b-button size="sm"
                              key="remove"
                              variant="outline-danger"
                              v-on:click="removeBlankAudioSegment(row)">

                        <i class="fas fa-times"></i> Remove
                    </b-button>
                </b-button-group>
            </template>
        </b-table>


        <ul class="list-group list-group-flush" v-if="canAddMoreSegments">
            <li class="list-group-item">
                <b-alert v-model="showAlertMessage" variant="danger" dismissible>
                    <p>{{ alertMessage }}</p>
                </b-alert>

                <!--MIN time: {{ workItemStartTime }}<br />MAX ti me: {{ workItemEndTime }}-->

                <b-form-row>

                    <b-form-group label="Start time"
                                    label-for="startTime"
                                    class="col-md-3">
                        <b-form-input ref="startTime"
                                        name="startTime"
                                        type="time"
                                        step="1"
                                        v-model="currentBlankAudioSegment.startTime">
                        </b-form-input>
                    </b-form-group>
                    <b-form-group label="End time"
                                    label-for="endTime"
                                    class="col-md-3">
                        <b-form-input ref="endTime"
                                        name="endTime"
                                        type="time"
                                        step="1"
                                        v-model="currentBlankAudioSegment.endTime">
                        </b-form-input>
                    </b-form-group>
                    <b-form-group label="Reason"
                                    label-for="blankSegementReason"
                                    class="col-md-4">
                        <select2 name="blankSegementReason"
                                    placeholder="Select a reason"
                                    :text-property="allBlankAudioSegmentReasons.text"
                                    :value-property="allBlankAudioSegmentReasons.id"
                                    v-model="currentBlankAudioSegment.reason"
                                    :options="allBlankAudioSegmentReasons"
                                    disable-search>
                        </select2>
                    </b-form-group>
                        
                    <b-form-group label="Action"
                                    class="col-md-2 pl-3">
                        <b-button variant="outline-secondary" v-on:click="saveBlankAudioSegment"><i class="fas fa-plus mr-1"></i>Add</b-button>
                    </b-form-group>
                </b-form-row>
            </li>
        </ul>
    </div>
</template>

<script>
    //import $ from 'jquery';
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';

    import DateTimeMixin from '../mixins/DateTimeMixin';
    import ErrorsMixin from '../mixins/ErrorsMixin';
    import Select2 from './Select2';

    Vue.use(BootstrapVue);
    Vue.component('select2', Select2);

    export default {
        name: 'BlankAudioSegments',
        mixins: [DateTimeMixin, ErrorsMixin],
        model: {
            event: 'change',
            prop: 'active',
        },
        props: {
            workItemId: {
                type: String,
                required: false
            },

            blankAudioSegments: {
                type: Array,
                required: true
            },
            allBlankAudioSegmentReasons: {
                type: Array,
                required: true
            },
            modifyOnly: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                blankAudioSegmentsLocal: this.blankAudioSegments,
                dialogOpen: this.active,
                blankAudioSegmentsUpdated: false,

                // get start time of first turn
                //workItemStartTime: this.parseDateTime(this.turnTranscriptWorkItems[0].startTime, 'HH:mm:ss'),
                // get end time of last turn
                //workItemEndTime: this.parseDateTime(this.turnTranscriptWorkItems.reverse()[0].endTime, 'HH:mm:ss'),

                showAlertMessage: false,
                alertMessage: '',

                currentBlankAudioSegment: {
                    segmentId: null,
                    startTime: null,
                    endTime: null,
                    reason: null
                },
                currentErrors: []
            };
        },
        watch: {
            readonly: function () {
                this.reload(true);
            },
            active: function () {
                this.dialogOpen = this.active;
            },
        },
        computed: {
            tableFields: function () {
                var fields = [
                    {
                        key: 'startTime',
                        label: 'Start time',
                        formatter: value => {
                            return this.formatDateTime(value, 'hh:mm:ssa', false);
                        },
                        class: 'fit'
                    },
                    {
                        key: 'endTime',
                        label: 'End time',
                        formatter: value => {
                            return this.formatDateTime(value, 'hh:mm:ssa', false);
                        },
                        class: 'fit'
                    },
                    {
                        key: 'reasonDisplayName',
                        label: 'Reason'
                    }
                ];
                fields.push(
                    {
                        key: 'actions',
                        label: 'Actions',
                        class: 'fit'
                    }
                );
                return fields;
            },

            canAddMoreSegments: function () {

                return true;
                // this probaly needs to be thought through
                //if (this.readonly) return false;
                //if (this.modifyOnly) return false;
                //if ((this.blankAudioSegmentsLocal == null) || (this.blankAudioSegmentsLocal.length == 0)) return true;
            }
        },
        methods: {

            saveBlankAudioSegment: function () {


                var blankSegmentOverlap = false;
                this.showAlertMessage = false;

                if ((this.currentBlankAudioSegment.startTime == null) ||
                    (this.currentBlankAudioSegment.endTime == null) ||
                    (this.currentBlankAudioSegment.reason == null)) {
                    this.alertMessage = 'Start time, End time and Reason are required.'
                    this.showAlertMessage = true;
                    return false;
                }
                //the time input controls only produce a string HH:mm:ss (where the ss can be missing)
                //now we convert those strings into datetime objects (input is a local time, output should also be a local time) which initially will have the current date set
                //so in the next step we change the date component of that datetime object to be the same as any existing blank audio segments
                //thus we can later do overlap checking
                var referenceDate = this.now();
                if (this.blankAudioSegmentsLocal.length > 0) referenceDate = this.blankAudioSegmentsLocal[0].startTime;
                var newBlankAudioSegment = {
                    startTime: this.setDateComponent(this.parseDateTime(this.currentBlankAudioSegment.startTime, 'HH:mm:ss', false, false), referenceDate),
                    endTime: this.setDateComponent(this.parseDateTime(this.currentBlankAudioSegment.endTime, 'HH:mm:ss', false, false), referenceDate),

                    reason: this.currentBlankAudioSegment.reason,
                    reasonDisplayName: this.allBlankAudioSegmentReasons.find(e => e.value == this.currentBlankAudioSegment.reason).text
                }
                if (newBlankAudioSegment.startTime > newBlankAudioSegment.endTime) {
                    this.alertMessage = 'Start time must be smaller than end time.'
                    this.showAlertMessage = true;
                    return false;
                }

                if ((newBlankAudioSegment.endTime - newBlankAudioSegment.startTime)/1000 < 60) {
                    this.alertMessage = 'Blank audio segment is too short: 60 seconds minimum';
                    this.showAlertMessage = true;
                    return false;
                }

                // if there are existing blank audio segments present ... check if overlap happens
                if (this.blankAudioSegmentsLocal.length > 0) {  
                    
                    this.blankAudioSegmentsLocal.forEach(existingBlankAudioSegment => {

                        //console.log('Start blank: ' + existingBlankAudioSegment.startTime);
                        //console.log('End blank: ' + existingBlankAudioSegment.endTime);
                        //console.log('start new blank: ' + newBlankAudioSegment.startTime);
                        //console.log('end new blank: ' + newBlankAudioSegment.endTime);
                        //console.log('==============================')
                      
                        if ((existingBlankAudioSegment.endTime > newBlankAudioSegment.startTime) && (newBlankAudioSegment.endTime > existingBlankAudioSegment.startTime)) {
                            this.alertMessage = 'Blank audio segment is overlapping with an existing one.';
                            blankSegmentOverlap = true;
                            return false;
                        }                 

                    });
                }

                if (blankSegmentOverlap) {
                    this.showAlertMessage = true;
                } else {
                    this.blankAudioSegmentsLocal.push(newBlankAudioSegment);
                    this.blankAudioSegmentsUpdated = true;
                    this.currentBlankAudioSegment = {
                        segmentId: null,
                        startTime: null,
                        endTime: null,
                        reason: null
                    };
                }
            },

            removeBlankAudioSegment: function (audioSegment) {
                console.log(JSON.stringify(audioSegment.index));
                this.blankAudioSegmentsLocal.splice(audioSegment.index, 1);
            }
        },
        mounted: function () {
            
        }
    }
</script>